<template>
  <div>
    <h1>Not Found</h1>
    <p>The page you requested is not found.</p>
  </div>
</template>

<script>
export default {
  name: 'not-found',
  data () {
    return {
      msg: ''
    }
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// NotFoundPage.vue?01c9bedf